import React, {useEffect, useState } from 'react';
import { CampaignTag, useCampaignTagsLazyQuery, useCampaignTagsQuery } from '../../generated/graphql';
import {GraphQlSelect} from "./GraphQlSelect";
import {GraphQlSelectId} from "./GraphQlSelectId";

export const CampaignTagSelect = (props: any): JSX.Element => {
    const [tagFilter,setTagFilter] = useState('');
    const variables: any = {};
    if(tagFilter) { variables.name = '%'+tagFilter+'%'; }
    const campaignTagQueryResult = useCampaignTagsQuery({variables:variables});
    //const [siteTagPull,siteTagPullResult] = useCampaignTagsLazyQuery();
    //const localValues
    const renderOptionString = (item)=>{
        if(typeof item != 'string') {
            return item?item.name+':'+(item.description??''):'';
        }
    }
    const tagProps = (item:CampaignTag)=>{
        return {className:'section-'+(item?.section_code?.toLowerCase())};
    }
    return props.valueIsId?
        <GraphQlSelectId {...props} queryResult={campaignTagQueryResult} labelField="name" />:
        <GraphQlSelect {...props} renderOptionString={renderOptionString} queryResult={campaignTagQueryResult} labelField="name" />;
    //return <GraphQlTagSelect {...props}
}